import { createApp } from 'vue';
import ReplyAgentWidget from '@/components/ReplyAgentWidget.vue';
import { useWidgetStore } from '@/stores/widget';
import { pinia } from './pinia';

const app = createApp(ReplyAgentWidget);
app.use(pinia);

const store = useWidgetStore();

import { defineCustomElement } from 'vue';


const el = defineCustomElement(ReplyAgentWidget);


customElements.define('ra-chatbot-widget', el);



var style2 = document.createElement('style');

style2.innerHTML = `:root{--iti-hover-color:rgba(0, 0, 0, 0.05);--iti-border-color:#ccc;--iti-dialcode-color:#999;--iti-dropdown-bg:white;--iti-spacer-horizontal:8px;--iti-flag-height:12px;--iti-flag-width:16px;--iti-border-width:1px;--iti-arrow-height:4px;--iti-arrow-width:6px;--iti-triangle-border:calc(var(--iti-arrow-width) / 2);--iti-arrow-padding:6px;--iti-arrow-color:#555;--iti-path-flags-1x:url("../img/flags.webp");--iti-path-flags-2x:url("../img/flags@2x.webp");--iti-path-globe-1x:url("../img/globe.webp");--iti-path-globe-2x:url("../img/globe@2x.webp");--iti-flag-sprite-width:3904px;--iti-flag-sprite-height:12px;--iti-mobile-popup-margin:30px}.iti{position:relative;display:inline-block}.iti *{box-sizing:border-box}.iti__hide{display:none}.iti__v-hide{visibility:hidden}.iti__a11y-text{width:1px;height:1px;clip:rect(1px,1px,1px,1px);overflow:hidden;position:absolute}.iti input.iti__tel-input,.iti input.iti__tel-input[type=tel],.iti input.iti__tel-input[type=text]{position:relative;z-index:0;margin:0!important}.iti__country-container{position:absolute;top:0;bottom:0;padding:var(--iti-border-width)}.iti__selected-country{z-index:1;position:relative;display:flex;align-items:center;height:100%;background:0 0;border:0;margin:0;padding:0;font-family:inherit;font-size:inherit;color:inherit;border-radius:0;font-weight:inherit;line-height:inherit;text-decoration:none}.iti__selected-country-primary{display:flex;align-items:center;height:100%;padding:0 var(--iti-arrow-padding) 0 var(--iti-spacer-horizontal)}.iti__arrow{margin-left:var(--iti-arrow-padding);width:0;height:0;border-left:var(--iti-triangle-border) solid transparent;border-right:var(--iti-triangle-border) solid transparent;border-top:var(--iti-arrow-height) solid var(--iti-arrow-color)}[dir=rtl] .iti__arrow{margin-right:var(--iti-arrow-padding);margin-left:0}.iti__arrow--up{border-top:none;border-bottom:var(--iti-arrow-height) solid var(--iti-arrow-color)}.iti__dropdown-content{border-radius:3px;background-color:var(--iti-dropdown-bg)}.iti--inline-dropdown .iti__dropdown-content{position:absolute;z-index:2;margin-top:3px;margin-left:calc(var(--iti-border-width) * -1);border:var(--iti-border-width) solid var(--iti-border-color);box-shadow:1px 1px 4px rgba(0,0,0,.2)}.iti__search-input{width:100%;border-width:0;border-radius:3px}.iti__search-input+.iti__country-list{border-top:1px solid var(--iti-border-color)}.iti__country-list{list-style:none;padding:0;margin:0;overflow-y:scroll;-webkit-overflow-scrolling:touch}.iti--inline-dropdown .iti__country-list{max-height:185px}.iti--flexible-dropdown-width .iti__country-list{white-space:nowrap}@media (max-width:500px){.iti--flexible-dropdown-width .iti__country-list{white-space:normal}}.iti__country{display:flex;align-items:center;padding:8px var(--iti-spacer-horizontal);outline:0}.iti__dial-code{color:var(--iti-dialcode-color)}.iti__country.iti__highlight{background-color:var(--iti-hover-color)}.iti__country-list .iti__flag,.iti__country-name{margin-right:var(--iti-spacer-horizontal)}[dir=rtl] .iti__country-list .iti__flag,[dir=rtl] .iti__country-name{margin-right:0;margin-left:var(--iti-spacer-horizontal)}.iti--allow-dropdown .iti__country-container:not(:has(+ input[disabled])):not(:has(+ input[readonly])):hover,.iti--allow-dropdown .iti__country-container:not(:has(+ input[disabled])):not(:has(+ input[readonly])):hover button{cursor:pointer}.iti--allow-dropdown .iti__country-container:not(:has(+ input[disabled])):not(:has(+ input[readonly])) .iti__selected-country-primary:hover,.iti--allow-dropdown .iti__country-container:not(:has(+ input[disabled])):not(:has(+ input[readonly])) .iti__selected-country:has(+ .iti__dropdown-content:hover) .iti__selected-country-primary{background-color:var(--iti-hover-color)}.iti .iti__selected-dial-code{margin-left:4px}[dir=rtl] .iti .iti__selected-dial-code{margin-left:0;margin-right:4px}.iti--container{position:fixed;top:-1000px;left:-1000px;z-index:1060;padding:var(--iti-border-width)}.iti--container:hover{cursor:pointer}.iti--fullscreen-popup.iti--container{background-color:rgba(0,0,0,.5);top:0;bottom:0;left:0;right:0;position:fixed;padding:var(--iti-mobile-popup-margin);display:flex;flex-direction:column;justify-content:flex-start}.iti--fullscreen-popup .iti__dropdown-content{display:flex;flex-direction:column;max-height:100%;position:relative}.iti--fullscreen-popup .iti__country{padding:10px 10px;line-height:1.5em}.iti__flag{--iti-flag-offset:100px;height:var(--iti-flag-height);width:var(--iti-flag-width);border-radius:1px;box-shadow:0 0 1px 0 #888;background-image:var(--iti-path-flags-1x);background-repeat:no-repeat;background-position:var(--iti-flag-offset) 0;background-size:var(--iti-flag-sprite-width) var(--iti-flag-sprite-height)}.iti__ac{--iti-flag-offset:0px}.iti__ad{--iti-flag-offset:-16px}.iti__ae{--iti-flag-offset:-32px}.iti__af{--iti-flag-offset:-48px}.iti__ag{--iti-flag-offset:-64px}.iti__ai{--iti-flag-offset:-80px}.iti__al{--iti-flag-offset:-96px}.iti__am{--iti-flag-offset:-112px}.iti__ao{--iti-flag-offset:-128px}.iti__ar{--iti-flag-offset:-144px}.iti__as{--iti-flag-offset:-160px}.iti__at{--iti-flag-offset:-176px}.iti__au{--iti-flag-offset:-192px}.iti__aw{--iti-flag-offset:-208px}.iti__ax{--iti-flag-offset:-224px}.iti__az{--iti-flag-offset:-240px}.iti__ba{--iti-flag-offset:-256px}.iti__bb{--iti-flag-offset:-272px}.iti__bd{--iti-flag-offset:-288px}.iti__be{--iti-flag-offset:-304px}.iti__bf{--iti-flag-offset:-320px}.iti__bg{--iti-flag-offset:-336px}.iti__bh{--iti-flag-offset:-352px}.iti__bi{--iti-flag-offset:-368px}.iti__bj{--iti-flag-offset:-384px}.iti__bl{--iti-flag-offset:-400px}.iti__bm{--iti-flag-offset:-416px}.iti__bn{--iti-flag-offset:-432px}.iti__bo{--iti-flag-offset:-448px}.iti__bq{--iti-flag-offset:-464px}.iti__br{--iti-flag-offset:-480px}.iti__bs{--iti-flag-offset:-496px}.iti__bt{--iti-flag-offset:-512px}.iti__bw{--iti-flag-offset:-528px}.iti__by{--iti-flag-offset:-544px}.iti__bz{--iti-flag-offset:-560px}.iti__ca{--iti-flag-offset:-576px}.iti__cc{--iti-flag-offset:-592px}.iti__cd{--iti-flag-offset:-608px}.iti__cf{--iti-flag-offset:-624px}.iti__cg{--iti-flag-offset:-640px}.iti__ch{--iti-flag-offset:-656px}.iti__ci{--iti-flag-offset:-672px}.iti__ck{--iti-flag-offset:-688px}.iti__cl{--iti-flag-offset:-704px}.iti__cm{--iti-flag-offset:-720px}.iti__cn{--iti-flag-offset:-736px}.iti__co{--iti-flag-offset:-752px}.iti__cr{--iti-flag-offset:-768px}.iti__cu{--iti-flag-offset:-784px}.iti__cv{--iti-flag-offset:-800px}.iti__cw{--iti-flag-offset:-816px}.iti__cx{--iti-flag-offset:-832px}.iti__cy{--iti-flag-offset:-848px}.iti__cz{--iti-flag-offset:-864px}.iti__de{--iti-flag-offset:-880px}.iti__dj{--iti-flag-offset:-896px}.iti__dk{--iti-flag-offset:-912px}.iti__dm{--iti-flag-offset:-928px}.iti__do{--iti-flag-offset:-944px}.iti__dz{--iti-flag-offset:-960px}.iti__ec{--iti-flag-offset:-976px}.iti__ee{--iti-flag-offset:-992px}.iti__eg{--iti-flag-offset:-1008px}.iti__eh{--iti-flag-offset:-1024px}.iti__er{--iti-flag-offset:-1040px}.iti__es{--iti-flag-offset:-1056px}.iti__et{--iti-flag-offset:-1072px}.iti__fi{--iti-flag-offset:-1088px}.iti__fj{--iti-flag-offset:-1104px}.iti__fk{--iti-flag-offset:-1120px}.iti__fm{--iti-flag-offset:-1136px}.iti__fo{--iti-flag-offset:-1152px}.iti__fr{--iti-flag-offset:-1168px}.iti__ga{--iti-flag-offset:-1184px}.iti__gb{--iti-flag-offset:-1200px}.iti__gd{--iti-flag-offset:-1216px}.iti__ge{--iti-flag-offset:-1232px}.iti__gf{--iti-flag-offset:-1248px}.iti__gg{--iti-flag-offset:-1264px}.iti__gh{--iti-flag-offset:-1280px}.iti__gi{--iti-flag-offset:-1296px}.iti__gl{--iti-flag-offset:-1312px}.iti__gm{--iti-flag-offset:-1328px}.iti__gn{--iti-flag-offset:-1344px}.iti__gp{--iti-flag-offset:-1360px}.iti__gq{--iti-flag-offset:-1376px}.iti__gr{--iti-flag-offset:-1392px}.iti__gt{--iti-flag-offset:-1408px}.iti__gu{--iti-flag-offset:-1424px}.iti__gw{--iti-flag-offset:-1440px}.iti__gy{--iti-flag-offset:-1456px}.iti__hk{--iti-flag-offset:-1472px}.iti__hn{--iti-flag-offset:-1488px}.iti__hr{--iti-flag-offset:-1504px}.iti__ht{--iti-flag-offset:-1520px}.iti__hu{--iti-flag-offset:-1536px}.iti__id{--iti-flag-offset:-1552px}.iti__ie{--iti-flag-offset:-1568px}.iti__il{--iti-flag-offset:-1584px}.iti__im{--iti-flag-offset:-1600px}.iti__in{--iti-flag-offset:-1616px}.iti__io{--iti-flag-offset:-1632px}.iti__iq{--iti-flag-offset:-1648px}.iti__ir{--iti-flag-offset:-1664px}.iti__is{--iti-flag-offset:-1680px}.iti__it{--iti-flag-offset:-1696px}.iti__je{--iti-flag-offset:-1712px}.iti__jm{--iti-flag-offset:-1728px}.iti__jo{--iti-flag-offset:-1744px}.iti__jp{--iti-flag-offset:-1760px}.iti__ke{--iti-flag-offset:-1776px}.iti__kg{--iti-flag-offset:-1792px}.iti__kh{--iti-flag-offset:-1808px}.iti__ki{--iti-flag-offset:-1824px}.iti__km{--iti-flag-offset:-1840px}.iti__kn{--iti-flag-offset:-1856px}.iti__kp{--iti-flag-offset:-1872px}.iti__kr{--iti-flag-offset:-1888px}.iti__kw{--iti-flag-offset:-1904px}.iti__ky{--iti-flag-offset:-1920px}.iti__kz{--iti-flag-offset:-1936px}.iti__la{--iti-flag-offset:-1952px}.iti__lb{--iti-flag-offset:-1968px}.iti__lc{--iti-flag-offset:-1984px}.iti__li{--iti-flag-offset:-2000px}.iti__lk{--iti-flag-offset:-2016px}.iti__lr{--iti-flag-offset:-2032px}.iti__ls{--iti-flag-offset:-2048px}.iti__lt{--iti-flag-offset:-2064px}.iti__lu{--iti-flag-offset:-2080px}.iti__lv{--iti-flag-offset:-2096px}.iti__ly{--iti-flag-offset:-2112px}.iti__ma{--iti-flag-offset:-2128px}.iti__mc{--iti-flag-offset:-2144px}.iti__md{--iti-flag-offset:-2160px}.iti__me{--iti-flag-offset:-2176px}.iti__mf{--iti-flag-offset:-2192px}.iti__mg{--iti-flag-offset:-2208px}.iti__mh{--iti-flag-offset:-2224px}.iti__mk{--iti-flag-offset:-2240px}.iti__ml{--iti-flag-offset:-2256px}.iti__mm{--iti-flag-offset:-2272px}.iti__mn{--iti-flag-offset:-2288px}.iti__mo{--iti-flag-offset:-2304px}.iti__mp{--iti-flag-offset:-2320px}.iti__mq{--iti-flag-offset:-2336px}.iti__mr{--iti-flag-offset:-2352px}.iti__ms{--iti-flag-offset:-2368px}.iti__mt{--iti-flag-offset:-2384px}.iti__mu{--iti-flag-offset:-2400px}.iti__mv{--iti-flag-offset:-2416px}.iti__mw{--iti-flag-offset:-2432px}.iti__mx{--iti-flag-offset:-2448px}.iti__my{--iti-flag-offset:-2464px}.iti__mz{--iti-flag-offset:-2480px}.iti__na{--iti-flag-offset:-2496px}.iti__nc{--iti-flag-offset:-2512px}.iti__ne{--iti-flag-offset:-2528px}.iti__nf{--iti-flag-offset:-2544px}.iti__ng{--iti-flag-offset:-2560px}.iti__ni{--iti-flag-offset:-2576px}.iti__nl{--iti-flag-offset:-2592px}.iti__no{--iti-flag-offset:-2608px}.iti__np{--iti-flag-offset:-2624px}.iti__nr{--iti-flag-offset:-2640px}.iti__nu{--iti-flag-offset:-2656px}.iti__nz{--iti-flag-offset:-2672px}.iti__om{--iti-flag-offset:-2688px}.iti__pa{--iti-flag-offset:-2704px}.iti__pe{--iti-flag-offset:-2720px}.iti__pf{--iti-flag-offset:-2736px}.iti__pg{--iti-flag-offset:-2752px}.iti__ph{--iti-flag-offset:-2768px}.iti__pk{--iti-flag-offset:-2784px}.iti__pl{--iti-flag-offset:-2800px}.iti__pm{--iti-flag-offset:-2816px}.iti__pr{--iti-flag-offset:-2832px}.iti__ps{--iti-flag-offset:-2848px}.iti__pt{--iti-flag-offset:-2864px}.iti__pw{--iti-flag-offset:-2880px}.iti__py{--iti-flag-offset:-2896px}.iti__qa{--iti-flag-offset:-2912px}.iti__re{--iti-flag-offset:-2928px}.iti__ro{--iti-flag-offset:-2944px}.iti__rs{--iti-flag-offset:-2960px}.iti__ru{--iti-flag-offset:-2976px}.iti__rw{--iti-flag-offset:-2992px}.iti__sa{--iti-flag-offset:-3008px}.iti__sb{--iti-flag-offset:-3024px}.iti__sc{--iti-flag-offset:-3040px}.iti__sd{--iti-flag-offset:-3056px}.iti__se{--iti-flag-offset:-3072px}.iti__sg{--iti-flag-offset:-3088px}.iti__sh{--iti-flag-offset:-3104px}.iti__si{--iti-flag-offset:-3120px}.iti__sj{--iti-flag-offset:-3136px}.iti__sk{--iti-flag-offset:-3152px}.iti__sl{--iti-flag-offset:-3168px}.iti__sm{--iti-flag-offset:-3184px}.iti__sn{--iti-flag-offset:-3200px}.iti__so{--iti-flag-offset:-3216px}.iti__sr{--iti-flag-offset:-3232px}.iti__ss{--iti-flag-offset:-3248px}.iti__st{--iti-flag-offset:-3264px}.iti__sv{--iti-flag-offset:-3280px}.iti__sx{--iti-flag-offset:-3296px}.iti__sy{--iti-flag-offset:-3312px}.iti__sz{--iti-flag-offset:-3328px}.iti__tc{--iti-flag-offset:-3344px}.iti__td{--iti-flag-offset:-3360px}.iti__tg{--iti-flag-offset:-3376px}.iti__th{--iti-flag-offset:-3392px}.iti__tj{--iti-flag-offset:-3408px}.iti__tk{--iti-flag-offset:-3424px}.iti__tl{--iti-flag-offset:-3440px}.iti__tm{--iti-flag-offset:-3456px}.iti__tn{--iti-flag-offset:-3472px}.iti__to{--iti-flag-offset:-3488px}.iti__tr{--iti-flag-offset:-3504px}.iti__tt{--iti-flag-offset:-3520px}.iti__tv{--iti-flag-offset:-3536px}.iti__tw{--iti-flag-offset:-3552px}.iti__tz{--iti-flag-offset:-3568px}.iti__ua{--iti-flag-offset:-3584px}.iti__ug{--iti-flag-offset:-3600px}.iti__us{--iti-flag-offset:-3616px}.iti__uy{--iti-flag-offset:-3632px}.iti__uz{--iti-flag-offset:-3648px}.iti__va{--iti-flag-offset:-3664px}.iti__vc{--iti-flag-offset:-3680px}.iti__ve{--iti-flag-offset:-3696px}.iti__vg{--iti-flag-offset:-3712px}.iti__vi{--iti-flag-offset:-3728px}.iti__vn{--iti-flag-offset:-3744px}.iti__vu{--iti-flag-offset:-3760px}.iti__wf{--iti-flag-offset:-3776px}.iti__ws{--iti-flag-offset:-3792px}.iti__xk{--iti-flag-offset:-3808px}.iti__ye{--iti-flag-offset:-3824px}.iti__yt{--iti-flag-offset:-3840px}.iti__za{--iti-flag-offset:-3856px}.iti__zm{--iti-flag-offset:-3872px}.iti__zw{--iti-flag-offset:-3888px}.iti__globe{background-image:var(--iti-path-globe-1x);background-size:contain;background-position:right;box-shadow:none;height:19px}@media (min-resolution:2x){.iti__flag{background-image:var(--iti-path-flags-2x)}.iti__globe{background-image:var(--iti-path-globe-2x)}}`;





var host = document.querySelector('ra-chatbot-widget');
if (!host) {

  host = document.getElementById('ra_wc_chatbot');
}


host.shadowRoot.appendChild(style2)


var style = document.createElement('style');

if (host) {
  setTimeout(function () {
    if (store.getWidgetInfo().widgetType == "lagacy") {


      style.innerHTML = `

        
        /* Chatbox */
        .ra_wc_chatbox {
          height: 60vh;
          
          position: fixed;
          bottom: 5rem;
          
          width: 20rem;
          background-color: white;
          border-radius: 0.5rem;
          box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
          border: 1px solid #ddd;
          z-index:9999;
        }

        /* Chat Header */
        .ra_wc_chatbox_header {
          display: flex;
          align-items: center;
          padding: 15px;
          border-radius: 12px 12px 0 0;
        }

        /* Avatar */
        .ra_wc_avatar {
          width: 2.5rem;
          height: 2.5rem;
          border-radius: 9999px;
          border: 1px dashed gray;
          background-color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          color: gray;
        }
        .ra_wc_avatar img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 9999px;
        }

      .ra_wc_chat_wrapper {
          flex: 1;
          padding: 10px;
          overflow-y: auto;
          background: #f9f9f9;
          display: flex;
          flex-direction: column;
         height: 58vh;
         max-height: calc(58vh - 150px);
        }

        .ra_wc_message_group {
          display: flex;
          flex-direction: column;
          margin-bottom: 10px;
        }

        .ra_wc_message {
     

        clear: both;
        float: left;
        padding: 6px 10px;
        border-radius: 20px 20px 20px 0;
        background: #eee;
        margin: 8px 0;
        font-size: 14px;
        line-height: 1.4;
        position: relative;
        border: 1px solid #ccc;
        max-width: 80%;
       
        white-space: normal;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
         word-break: break-word;
          overflow-wrap: break-word; 
        }

        .ra_wc_message .ra_wc_buttons_list{
            display: block;
            width:100%;
        }

        .ra_wc_message .ra_wc_buttons_list .ra_wc_button{
          display: block;
          width: 100%;
          margin-top: 5px;
          padding: 10px;
          text-align: center;
          cursor: pointer;
          background-color: var(--raw-bg);
          color: var(--ra-text-color);
          border-radius: 8px;
        }

        .ra_wc_user {
          align-self: flex-end;
          border-radius: 20px 20px 0 20px;
          border: 1px solid var(--raw-bg);
          align-items: flex-end;
        }
        
        /* Chat Input */
      .ra_wc_message_box {
        position: absolute;
        bottom: 10px; /* Keep spacing from the bottom */
        left: 50%;
        transform: translateX(-50%);
        width: 90%;
        max-width: 600px;
        background: #fff;
        padding: 6px; /* Ensures equal padding on all sides */
        border: 1px solid #ccc;
        border-radius: 20px;
        min-height: 38px;
        max-height: 200px;
        overflow-y: auto;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        transition: all 0.2s ease-in-out;
        z-index: 1000;
      }
      .ra_wc_message_input {
        flex: 1;
        border: none;
        outline: none;
        font-size: 14px;
        min-height: 18px;
        padding-left: 8px;
        color: #444;
        background: none;
        resize: none;
      }

      .ra_wc_message_actions {
        display: flex;
        align-items: center;
        gap: 4px;
      }

      .ra_wc_icon {
        background: none;
        border: none;
        cursor: pointer;
        font-size: 14px;
        padding: 3px;
        transition: transform 0.2s ease;
      }

      .ra_wc_icon:hover {
        transform: scale(1.1);
      }

      
        /* Message Timestamp */
        .ra_wc_agent_name {
          position: absolute;
          bottom: -15px;
          font-size: 10px;
          color: #555;
          right: 60px;
          
        }
    
        .ra_wc_checkmark-sent-delivered {
          position: absolute;
          bottom: -15px;
          right: 10px;
          font-size: 12px;
          color: #999;
        }
        .ra_wc_checkmark-read {
          color: blue;
          position: absolute;
          bottom: -15px;
          right: 16px;
          font-size: 12px;
        }

        /* Loading Messages */
        .ra_wc_message.ra_wc_loading span {
          display: block;
          font-size: 0;
          width: 20px;
          height: 10px;
          position: relative;
        }

        /* Scrollbar */
        .ra_wc_scrollbar {
          margin: 1px -3px 1px 0;
          opacity: 0;
        }
        .ra_wc_scrollbar_inside > .ra_wc_scrollbar_container {
          margin-right: 0px;
          padding: 0 10px;
        }
        .ra_wc_scrollbar .ra_wc_scrollbar_dragger .ra_wc_scrollbar_dragger_bar {
          background-color: rgba(0, 0, 0, 0.5) !important;
        }

        .ra_wc_wel_chat-widget  {
                  width: 18rem;
                  border: 1px solid #ddd;
                  padding: 15px;
                  background-color: gray;
                  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                  background-color: #e7e7e7;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  position: fixed;
                    bottom: 80px;
                    z-index:1000;
                    border-radius: 8px;
                  
                  
              }
              .ra_wc_wel_chat-content {
                  flex-grow: 1;
              }
              .ra_wc_wel_chat-content h4 {
                  margin: 0;
                  font-size: 16px;
                  font-weight: bold;
                  color: #222;
              }
              .ra_wc_wel_chat-content p {
                  margin: 5px 0;
                  font-size: 14px;
                  color: #666;
              }
              .ra_wc_wel_chat-content a {
                  display: inline-block;
                  margin-top: 5px;
                  font-size: 14px;
                  color: #007bff;
                  text-decoration: none;
              }
              .ra_wc_wel_chat-content a:hover {
                  text-decoration: underline;
              }
             
            .ra_wc_emoji-popup {
              position: absolute;
              bottom: 50px;
              left: 50%;
              transform: translateX(-50%);
              border-radius: 8px;
              z-index: 9999;
              padding: 10px;
            }

          
            @media only screen and (max-width: 768px) {
            .ra_wc_chatbox {
              height: 45vh; 
            }
          }
     
      `;
    }
    else {

      style.innerHTML = `
         /* Container */
          .ra_wc_container {
            height: 70vh;
            position: fixed;
            bottom: 5rem;
            width: 20rem;
            border: 1px solid #ccc;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            font-family: Arial, sans-serif;
            overflow: hidden;
            background: #fff;
            flex: 1;
            z-index:9999;
          }

          /* Header */
          .ra_wc_header {
            background: #e3d0f7;
            padding: 10px;
            display: flex;
            align-items: center;
            gap: 10px;
            flex-shrink: 0;
            justify-content: space-between;
          }

          .ra_wc_header_left {
            display: flex;
            align-items: center;
            gap: 10px;
          }

          .ra_wc_back_arrow {
            font-size: 20px;
            cursor: pointer;
          }

          .ra_wc_title {
            font-weight: bold;
            font-size: 14px;
          }

          .ra_wc_subtitle {
            font-size: 12px;
            color: #666;
          }

          .ra_wc_header_right {
            position: relative;
          }

          .ra_wc_minimize,
          .ra_wc_dropdown_toggle {
            font-size: 18px;
            cursor: pointer;
            margin-left: 3px;
          }

          .ra_wc_dropdown_menu {
            position: absolute;
            left: 0;  /* Adjust this line for left alignment */
            top: 25px;
            background: #fff;
            border: 1px solid #ccc;
            border-radius: 6px;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
            display: none;
            z-index: 99;
          }

          .ra_wc_dropdown_menu div {
            padding: 8px 12px;
            font-size: 13px;
            cursor: pointer;
          }

          .ra_wc_dropdown_menu div:hover {
            background: #f0f0f0;
          }

          /* Chat Area */
          .ra_wc_chat_wrapper {
            flex: 1;
            padding: 10px;
            overflow-y: auto;
            background: #f9f9f9;
            display: flex;
            flex-direction: column;
          }

          .ra_wc_message_group {
            display: flex;
            flex-direction: column;
            margin-bottom: 10px;
          }

          .ra_wc_message {
            background: #fff;
            padding: 10px;
            border-radius: 8px;
            margin-bottom: 5px;
            font-size: 14px;
            max-width: 90%;
            word-break: break-word;
            overflow-wrap: break-word;
          }

          .ra_wc_message .ra_wc_buttons_list{
            display: block;
            width:100%;
          }

          .ra_wc_message .ra_wc_buttons_list .ra_wc_button{
            display: block;
            width: 100%;
            margin-top: 5px;
            padding: 10px;
            text-align: center;
            cursor: pointer;
            background-color: var(--raw-bg);
            color: var(--ra-text-color);
            border-radius: 8px;
          }

          .ra_wc_user {
            align-self: flex-end;
            background: #e0f7fa;
          }


          /* Input Area */
          .ra_wc_input_area {
            margin-top: auto;
           
           
          }

          .ra_wc_input_box {
           
            background: white;
            padding: 8px 12px 4px;
            display: flex;
            flex-direction: column;
            
          }

          .ra_wc_textarea {
            width: 100%;
            border: none;
            resize: none;
            outline: none;
            font-size: 14px;
            padding: 0;
            margin: 0;
            font-family: inherit;
            height: 25px;
            color: #333;
          }

          .ra_wc_input_footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
           
          }

          .ra_wc_icon {
            font-size: 14px;
            margin-right: 8px;
            color: #555;
            cursor: pointer;
          }

          .ra_wc_send_button {
            margin-left: auto;
            background: transparent;
            border: none;
            font-size: 16px;
            cursor: pointer;
            color: #222;
            padding: 4px;
          }

          /* Footer */
          .ra_wc_footer {
            font-size: 10px;
            text-align: center;
            padding: 6px 10px;
            color: #666;
            flex-shrink: 0;
          }
          .ra_wc_sound_toggle {
            cursor: pointer;
          }

          .ra_wc_sound_toggle i {
            font-size: 18px;
          }
            .ra_wc_input_box p {
              margin:0px;
              padding-bottom:5px;
            }
              .ra_wc_input_box a {
              padding-bottom:5px;
            }
            .ra_wc_emoji-popup {
              position: absolute;
              bottom: 95px;
              left: 50%;
              transform: translateX(-50%);
              border-radius: 8px;
              z-index: 9999;
              padding: 10px;
            }
            .right-header-text {
                margin-left : 3px;
            }
        `;

    }



    const widgetUrl = process.env.VUE_APP_RA_WIDGET_URL;

    style.innerHTML += `

     
    .iti__flag {
    background-image: url('${widgetUrl}/img/flags.192a0002.webp') !important;
  }
    .phone-container {
      position: relative;
    }
      .iti--container {
  z-index: 100000000 !important;
  position: absolute !important;
}

.iti--inline-dropdown .iti__dropdown-content{

    margin-top:-239px !important;
}

.iti__tel-input {
 width: 270px !important;
}

.iti--container .iti__country-list {
  margin-bottom: 4px;
  max-height: 300px;
  overflow-y: auto;
}
      .bubble{
         z-index:9999;
      }
         .ra_wc_chat-typing {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 5px;
          }

          .ra_wc_dot {
            width: 8px;
            height: 8px;
            background-color: #555;
            border-radius: 50%;
            animation: ra_wc_bounce 1.4s infinite ease-in-out both;
          }

          .ra_wc_dot:nth-child(1) {
            animation-delay: 0s;
          }
          .ra_wc_dot:nth-child(2) {
            animation-delay: 0.2s;
          }
          .ra_wc_dot:nth-child(3) {
            animation-delay: 0.4s;
          }

          @keyframes ra_wc_bounce {
            0%, 80%, 100% {
              transform: scale(0.6);
              opacity: 0.3;
            }
            40% {
              transform: scale(1);
              opacity: 1;
            }
          }
       .ra_wc_wel_chat-avatar {
                    width: 40px;
                    height: 40px;
                    border-radius: 5px;
                    border: 1px solid #ddd;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: bold;
                    font-size: 14px;
                }
      .ra-wc-image-preview {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          gap: 5px;
          margin-bottom: 5px;
        }

        .ra-wc-file-preview {
          position: relative; /* Needed for absolute positioning */
          display: flex;
          align-items: center;
          padding: 5px;
          background: #f1f1f1;
          border-radius: 5px;
          width: 40px; /* Adjust width */
          height: 30px; /* Adjust height */
          justify-content: center;
        }

        .ra-wc-preview-img {
          max-width: 40px;
          max-height: 40px;
          border-radius: 5px;
        }

        .ra-wc-remove-preview {
          position: absolute;
          top: 0;
          right: 0;
          background: red;
          color: white;
          border: none;
          font-size: 12px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
        }
          .ra-wc-file-name
          {
            font-size:11px
          }
       .ra_wc-p-5 {
          padding: 1.25rem;
        }

        .ra_wc-rounded-t-lg {
          border-top-left-radius: 0.5rem;
          border-top-right-radius: 0.5rem;
        }


        /* Flex and Alignment */
        .ra_wc-flex {
          display: flex;
        }

        .ra_wc-items-center {
          align-items: center;
        }

        .ra_wc-space-x-3 > *:not(:last-child) {
          margin-right: 0.75rem;
        }

        /* Avatar */
        .ra_wc-w-10 {
          width: 2.5rem;
        }

        .ra_wc-h-10 {
          height: 2.5rem;
        }

      .ra_wc-w-8 {
          width: 2rem;
        }

       .ra_wc-h-8 {
          height: 2rem;
        }

        .ra_wc-rounded-full {
          border-radius: 50%;
        }

        .ra_wc-bg-white {
          background-color: white;
        }

        .ra_wc-text-gray-400 {
          color: #9ca3af;
        }

        .ra_wc-text-primary-400 {
          color: #3b82f6; /* Adjust as needed */
        }

        /* Avatar Image */
        .ra_wc-w-full {
          width: 100%;
        }

        .ra_wc-h-full {
          height: 100%;
        }

        .ra_wc-object-cover {
          object-fit: cover;
        }

        /* Typography */
        .ra_wc-text-lg {
          font-size: 1.125rem;
        }

        .ra_wc-font-semibold {
          font-weight: 600;
        }

        .ra_wc-text-sm {
          font-size: 0.875rem;
        }
          /* Positioning */
          .ra_wc_absolute { position: absolute; }
          .ra_wc_relative { position: relative; }
          .ra_wc_fixed { position: fixed; }
          .ra_wc_bottom-6 { bottom: 1.5rem; }
          .ra_wc_right-6 { right: 1.5rem; }
          .ra_wc_left-6 { left: 1.5rem; }
          
          /* Text & Color */
        

          /* Sizing */
          .ra_wc_w-12 { width: 3rem; }
          .ra_wc_h-12 { height: 3rem; }
          .ra_wc_w-auto { width: auto; }
          .ra_wc_h-40px { height: 40px; }
          .ra_wc_min-w-40px { min-width: 40px; }
          .ra_wc_w-8 { width: 2rem; }
          .ra_wc_h-8 { height: 2rem; }
          .ra_wc_-mt-2 { margin-top: -0.5rem; }

              /* for retracted */

          .ra_wc_w_r-12 { width: 4.5rem; }
          .ra_wc_h_r-12 { height: 4.5rem; }
          .ra_wc_w-r-8 { width: 3rem; }
          .ra_wc_h-r-8 { height: 3rem; }
          

          /* Spacing & Layout */
          .ra_wc_p-3 { padding: 0.75rem; }
          .ra_wc_space-x-2 > *:not(:last-child) { margin-right: 0.5rem; }
          .ra_wc_space-x-3 > *:not(:last-child) { margin-right: 0.75rem; }

          /* Border & Radius */
          .ra_wc_rounded-full { border-radius: 9999px; }

          /* Flexbox */
          .ra_wc_flex { display: flex; align-items: center; }
          .ra_wc_items-center { align-items: center; }
          .ra_wc_justify-center { justify-content: center; }

          /* Floating Chat Bubble */
          .ra_wc_bubble
          {
            position: fixed;
            bottom: 1.5rem;
            display: flex;
            align-items: center;
            padding: 0.75rem;
            border-radius: 9999px;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            cursor: pointer;
          }
          .right { right: 1.5rem; }
          .ra_wc_bubble.right { right: 1.5rem; }
          .ra_wc_bubble.left { left: 1.5rem; }
          .ra_wc_bubble img { margin-right: 0.5rem; } 

       .ra_wc_text-white {  color:var(--ra-text-color) } 
       .ra_wc_bg { background:var(--raw-bg) } 
          .pointer{
              cursor: pointer;
            }
              .ra_wc_message_image_thumb{
              border: 2px solid #ccc;
              border-radius: 5px;
              padding: 2px;
              max-width: 100%; /* Ensure it doesn't overflow */
              
              }

              .ra_wc_message_image_thumb img{

                width:100px;
                height:100px;
              }

        .ra_wc_spinner-container {
          display: flex;
          align-items: center;
          margin-right: 2px; /* Spacing between buttons and spinner */
        }

        .ra_wc_spinner {
          width: 12px;
          height: 12px;
          border: 3px solid rgba(0, 0, 0, 0.2);
          border-top: 3px solid #3498db;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .ra_wc_small-audio-player {
          width: 150px;
          height: 25px;
        }
         .ra_wc_info-label {
                    display: block;
                    font-weight: bold;
                    margin-bottom: 5px;
                }
                .ra_wc_info-input-wrapper {
                    display: flex;
                    align-items: center;
                    border: 1px solid #ccc;
                    border-radius: 5px;
                    overflow: hidden;
                    width: 100%;
                }
                .ra_wc_info-input-wrapperP {
                  display: flex;
                  align-items: center;
                  border: 1px solid #ccc;
                  border-radius: 5px;
                  
                  width: 100%;
              }
                .ra_wc_info-input {
                    flex: 1;
                    padding: 8px;
                    border: none;
                    outline: none;
                    width:auto;
                }
                .ra_wc_info-button {
                    color: white;
                    border: none;
                    padding: 10px;
                    cursor: pointer;
                }
              .ra_wc_error-message {
                  color: red;
                  font-weight: bold;
                  font-size: 12px;
                  margin-top: 5px;
                  display: block;
                }
                .ra_wc_width{
                  width:100%;
                }
         .v3-footer {
            display: none !important;
        }
       .ra_wc_message div > p {
          margin: 0px;
        }

         .ra_wc_bot {
            align-self: flex-start;
          }

          .ra_wc_timestamp {
            font-size: 11px;
            color: #999;
             margin: 0px 0px 7px 0px;
            text-align: left;
          }
          .ra_wc_timestamp_user {
            font-size: 11px;
            color: #999;
            margin: 0px 0px 7px 0px;
            text-align: right;
          }
         .chat-badge {
          position: absolute;
          top: -15px;
          right: 10px;
          background-color: red;
          color: white;
          font-size: 14x;
          padding: 2px 6px;
          border-radius: 50%;
          font-weight: bold;
        }
       .v3-body-inner{scroll-behavior:smooth;scrollbar-color:#393d3f rgba(0,0,0,.1);scrollbar-width:thin}.v3-body-inner::-webkit-scrollbar{width:8px}.v3-body-inner::-webkit-scrollbar-track{background-color:transparent}.v3-body-inner::-webkit-scrollbar-thumb{display:none;background:rgba(0,0,0,.3);border-radius:5px}.v3-body-inner:hover::-webkit-scrollbar-thumb{display:block}.v3-emoji-picker{height:320px;width:280px;box-shadow:0 2px 10px #0003;border-radius:10px;margin:0 auto;box-sizing:border-box;display:flex;flex-direction:column;text-align:left}.v3-emoji-picker *{box-sizing:border-box}.v3-emoji-picker .v3-header{padding:15px 15px 13px;border-bottom:1px solid}.v3-emoji-picker .v3-header .v3-groups{display:flex}.v3-emoji-picker .v3-header .v3-groups .v3-group{flex-grow:1;padding:0;margin:0;border:none;background:none;font-size:23px;cursor:pointer;position:relative;display:block;opacity:.7;transition:.2s}.v3-emoji-picker .v3-header .v3-groups .v3-group.v3-is-hidden{display:none}.v3-emoji-picker .v3-header .v3-groups .v3-group:first-child,.v3-emoji-picker .v3-header .v3-groups .v3-group:last-child{flex-grow:0}.v3-emoji-picker .v3-header .v3-groups .v3-group:hover{opacity:1}.v3-emoji-picker .v3-header .v3-groups .v3-group span{display:flex;align-items:center;justify-content:center}.v3-emoji-picker .v3-header .v3-groups .v3-group span img{display:block;width:1em;height:auto}.v3-emoji-picker .v3-spacing{height:11px}.v3-emoji-picker .v3-search input{width:100%;display:block;height:26px;padding:0 10px;border:1px solid;border-radius:3px;font-size:12px;transition:.2s}.v3-emoji-picker .v3-search input:focus{outline:none}.v3-emoji-picker .v3-body{padding:0 0 15px 11px;min-height:0;flex-grow:1}.v3-emoji-picker .v3-body .v3-body-inner{flex-grow:1;min-height:0;overflow-y:auto;overflow-x:hidden;height:100%;padding-right:11px}.v3-emoji-picker .v3-body .v3-body-inner .v3-group h5{margin:0;top:0;padding:7px 0 3px 4px;z-index:2}.v3-emoji-picker .v3-body .v3-body-inner .v3-group h5.v3-sticky{position:sticky}.v3-emoji-picker .v3-body .v3-body-inner .v3-group .v3-emojis{display:flex;font-size:18px;flex-wrap:wrap}.v3-emoji-picker .v3-body .v3-body-inner .v3-group .v3-emojis button{cursor:pointer;border:none;background:none;margin:0;text-align:center;display:flex;align-items:center;justify-content:center;flex-basis:12.5%;max-width:12.5%;flex-grow:1;padding:0;font-size:22px;position:relative}.v3-emoji-picker .v3-body .v3-body-inner .v3-group .v3-emojis button:after{content:"";width:100%;padding-bottom:100%}.v3-emoji-picker .v3-body .v3-body-inner .v3-group .v3-emojis button span{display:flex;align-items:center;justify-content:center}.v3-emoji-picker .v3-body .v3-body-inner .v3-group .v3-emojis button img{max-width:100%;padding:4px}.v3-emoji-picker .v3-body .v3-body-inner .v3-group .v3-emojis button span,.v3-emoji-picker .v3-body .v3-body-inner .v3-group .v3-emojis button img{position:absolute;top:0;left:0;width:100%;height:100%}.v3-emoji-picker .v3-body .v3-body-inner.is-mac .v3-emojis button{font-family:"Apple Color Emoji"}.v3-emoji-picker .v3-footer{font-size:14px;border-top:1px solid #dddddd;padding:15px;display:flex;align-items:center;justify-content:space-between;position:relative}.v3-emoji-picker .v3-footer .v3-tone,.v3-emoji-picker .v3-footer .v3-foot-left{display:flex;align-items:center}.v3-emoji-picker .v3-footer .v3-tone img,.v3-emoji-picker .v3-footer .v3-foot-left img{width:20px;display:block}.v3-emoji-picker .v3-footer .v3-tone>span:first-child,.v3-emoji-picker .v3-footer .v3-foot-left>span:first-child{margin-right:6px}.v3-emoji-picker .v3-footer .v3-foot-left>span.v3-text{max-width:100px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.v3-emoji-picker .v3-footer .v3-tone{border:none;padding:0;background:none;cursor:pointer;display:inline-flex;align-items:center}.v3-emoji-picker .v3-footer .v3-tone>span{display:inline-flex;vertical-align:top}.v3-emoji-picker .v3-footer .v3-tone .v3-text{font-size:13px}.v3-emoji-picker .v3-footer .v3-tone .v3-icon{display:inline-flex;height:15px;width:15px;vertical-align:middle;align-self:center;border:2px solid rgba(0,0,0,.2)}.v3-emoji-picker .v3-footer .v3-tone .v3-icon.v3-tone-neutral{background-color:#ffd225}.v3-emoji-picker .v3-footer .v3-tone .v3-icon.v3-tone-1f3fb{background-color:#ffdfbd}.v3-emoji-picker .v3-footer .v3-tone .v3-icon.v3-tone-1f3fc{background-color:#e9c197}.v3-emoji-picker .v3-footer .v3-tone .v3-icon.v3-tone-1f3fd{background-color:#c88e62}.v3-emoji-picker .v3-footer .v3-tone .v3-icon.v3-tone-1f3fe{background-color:#a86637}.v3-emoji-picker .v3-footer .v3-tone .v3-icon.v3-tone-1f3ff{background-color:#60463a}.v3-emoji-picker .v3-footer .v3-tone .is-mac span{font-family:"Apple Color Emoji"}.v3-skin-tones{position:absolute;height:100%;width:60%;top:0;left:0;display:flex;align-items:center;justify-content:flex-end;padding:0 15px;opacity:0;visibility:hidden;transition:.2s;border-radius:0 0 10px 10px}.v3-skin-tones.v3-is-open{opacity:1;visibility:visible}.v3-skin-tones .v3-skin-tone{display:inline-block;height:15px;width:25px;border:none;padding:0;cursor:pointer;transition:0ms}.v3-skin-tones .v3-skin-tone:hover{transform:scale(1.1);transition:.2s}.v3-skin-tones .v3-skin-tone-neutral{color:#ffd225;background-color:#ffd225}.v3-skin-tones .v3-skin-tone-1f3fb{color:#ffdfbd;background-color:#ffdfbd}.v3-skin-tones .v3-skin-tone-1f3fc{color:#e9c197;background-color:#e9c197}.v3-skin-tones .v3-skin-tone-1f3fd{color:#c88e62;background-color:#c88e62}.v3-skin-tones .v3-skin-tone-1f3fe{color:#a86637;background-color:#a86637}.v3-skin-tones .v3-skin-tone-1f3ff{color:#60463a;background-color:#60463a}.v3-input-emoji-picker *{box-sizing:border-box}.v3-input-emoji-picker .v3-input-picker-root{position:relative}.v3-input-emoji-picker .v3-input-picker-root .v3-emoji-picker-input,.v3-input-emoji-picker .v3-input-picker-root .v3-emoji-picker-textarea{width:100%;height:40px;border:1px solid #999;padding-left:15px}.v3-input-emoji-picker .v3-input-picker-root .v3-emoji-picker-textarea{min-height:80px;resize:vertical}.v3-input-emoji-picker .v3-input-picker-root .v3-emoji-picker-textarea+.v3-input-picker-wrap .v3-input-picker-icon{top:auto;bottom:5px}.v3-input-emoji-picker .v3-input-picker-root .v3-input-picker-wrap .v3-input-picker-icon{display:inline-flex;position:absolute;right:5px;top:50%;transform:translateY(-50%);font-size:24px;border:none;background:none;padding:0 5px;cursor:pointer}.v3-input-emoji-picker .v3-input-picker-root .v3-input-picker-wrap .v3-input-picker-icon img{display:block;width:1em;height:1em}.v3-input-emoji-picker .v3-input-picker-root .v3-input-picker-wrap .v3-emoji-picker{opacity:0;visibility:hidden;transition:.2s}.v3-input-emoji-picker .v3-input-picker-root .v3-input-picker-wrap.v3-picker-is-open .v3-emoji-picker{opacity:1;visibility:visible;z-index:999}.v3-emoji-picker{--v3-picker-bg: #ffffff;--v3-picker-fg: #000000;--v3-picker-border: #dddddd;--v3-picker-input-bg: var(--v3-picker-bg);--v3-picker-input-border: #cccccc;--v3-picker-input-focus-border: #000000;--v3-group-image-filter: none;--v3-picker-emoji-hover: #f7f7f7;background:var(--v3-picker-bg);color:var(--v3-picker-fg)}.v3-emoji-picker .v3-footer,.v3-emoji-picker .v3-header{border-color:var(--v3-picker-border)}.v3-emoji-picker .v3-groups{filter:var(--v3-group-image-filter)}.v3-emoji-picker .v3-tone{color:var(--v3-picker-fg)}.v3-emoji-picker .v3-search input{background:var(--v3-picker-input-bg);border-color:var(--v3-picker-input-border);color:inherit}.v3-emoji-picker .v3-search input:focus{border-color:var(--v3-picker-input-focus-border)}.v3-emoji-picker .v3-body .v3-body-inner .v3-group h5,.v3-emoji-picker .v3-skin-tones{background:var(--v3-picker-bg)}.v3-emoji-picker .v3-body .v3-body-inner .v3-group .v3-emojis button:hover{background:var(--v3-picker-emoji-hover, #f7f7f7)}@media (prefers-color-scheme: dark){.v3-emoji-picker.v3-color-theme-auto{--v3-picker-bg: #000000;--v3-picker-fg: #ffffff;--v3-picker-border: #333333;--v3-picker-input-bg: #222222;--v3-picker-input-border: #444444;--v3-picker-input-focus-border: #555555;--v3-group-image-filter: invert(1);--v3-picker-emoji-hover: #222222}}.v3-emoji-picker.v3-color-theme-dark{--v3-picker-bg: #000000;--v3-picker-fg: #ffffff;--v3-picker-border: #333333;--v3-picker-input-bg: #222222;--v3-picker-input-border: #444444;--v3-picker-input-focus-border: #555555;--v3-group-image-filter: invert(1);--v3-picker-emoji-hover: #222222}     `;
    host.shadowRoot.appendChild(style)

  }, 1000);

}